/**
 * Code to create placemarks for earth
 * @module
 *
 * @copyright Copyright 2009-2018, by the California Institute of Technology. ALL RIGHTS RESERVED.
 * United States Government Sponsorship acknowledged. Any commercial use must be
 * negotiated with the Office of Technology Transfer at the California Institute of Technology.
 */


module.exports = {
	Riyadh: {
		text: 'الرياض',
		latLng: [24.547123, 46.748093]
	},
	Yerevan: {
		text: 'يريفان',
		latLng: [40.183333, 44.516667]
	},
	Sydney: {
		text: 'سيدني',
		latLng: [-33.867139, 151.207114]
	},
	'La Paz': {
		text: 'لاباز',
		latLng: [-16.49901, -68.146248]
	},
	Bangkok: {
		text: 'بانكوك',
		latLng: [13.7234186, 100.4762319]
	},
	Houston: {
		text: 'هيوستن',
		latLng: [29.7632836, -95.3632715]
	},
	Vancouver: {
		text: 'فانكوفر',
		latLng: [49.263588, -123.138565]
	},
	Berlin: {
		text: 'برلين',
		latLng: [52.5234051, 13.4113999]
	},
	Bogota: {
		text: 'بوغوتا',
		latLng: [4.609866, -74.08205]
	},
	Manila: {
		text: 'مانيلا',
		latLng: [14.6010326, 120.9761599]
	},
	Lagos: {
		text: 'لاغوس',
		latLng: [6.441158, 3.417977]
	},
	Tehran: {
		text: 'طهران',
		latLng: [35.696216, 51.422945]
	},
	Istanbul: {
		text: 'اسطنبول',
		latLng: [41.012379, 28.975926]
	},
	Marrakesh: {
		text: 'مراكش',
		latLng: [31.631321, -8.012478]
	},
	Ulaanbaatar: {
		text: 'أولان باتور',
		latLng: [47.921378, 106.90554]
	},
	'New York': {
		text: 'نيويورك',
		latLng: [40.7142691, -74.0059729]
	},
	'Los Angeles': {
		text: 'لوس انجلوس',
		latLng: [34.0522342, -118.2436849]
	},
	Beijing: {
		text: 'بكين',
		latLng: [39.904667, 116.408198]
	},
	Tokyo: {
		text: 'طوكيو',
		latLng: [35.6894875, 139.6917064]
	},
	Johannesburg: {
		text: 'جوهانسبرج',
		latLng: [-26.201452, 28.045488]
	},
	Delhi: {
		text: 'دلهي',
		latLng: [28.635308, 77.22496]
	},
	Moscow: {
		text: 'موسكو',
		latLng: [55.755786, 37.617633]
	},
	Paris: {
		text: 'باريس',
		latLng: [48.8566667, 2.3509871]
	},
	'Rio De Janeiro': {
		text: 'ريو دي جانيرو',
		latLng: [-22.9035393, -43.2095869]
	},
	'Mexico City': {
		text: 'المكسيك',
		latLng: [19.4270499, -99.1275711]
	},
	London: {
		text: 'لندن',
		latLng: [51.5001524, -0.1262362]
	},
	Cairo: {
		text: 'القاهرة',
		latLng: [30.064742, 31.249509]
	},
	Mumbai: {
		text: 'مومباي',
		latLng: [19.017656, 72.856178]
	},
	Karachi: {
		text: 'كراتشي',
		latLng: [24.893379, 67.028061]
	},
	Honolulu: {
		text: 'هونولولو',
		latLng: [21.3069444, -157.8583333]
	},
	Anchorage: {
		text: 'الاسكا',
		latLng: [61.2180556, -149.9002778]
	},
	Shanghai: {
		text: 'شانقاهاي',
		latLng: [31.230708, 121.472916]
	},
	Miami: {
		text: 'ميامي',
		latLng: [25.7742657, -80.1936589]
	},
	'Kansas City': {
		text: 'ميزوري',
		latLng: [39.0997265, -94.5785667]
	},
	'Buenos Aires': {
		text: 'بوينس آيرس',
		latLng: [-34.6084175, -58.3731613]
	},
	Oslo: {
		text: 'اوسلو',
		latLng: [59.9138204, 10.7387413]
	},
	Singapore: {
		text: 'سنغافورة',
		latLng: [1.352083, 103.819836]
	},
	Lisbon: {
		text: 'لشبونة',
		latLng: [38.7071631, -9.135517]
	},
	Rome: {
		text: 'روما',
		latLng: [41.8954656, 12.4823243]
	},
	Perth: {
		text: 'برث',
		latLng: [-31.9554, 115.85859]
	},
	Darwin: {
		text: 'داروين',
		latLng: [-12.461334, 130.841904]
	},
	Christchurch: {
		text: 'كرايستشيرش',
		latLng: [-43.531637, 172.636645]
	},
	Guam: {
		text: 'غوام',
		latLng: [13.444304, 144.793731]
	}
};

